import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './methods.module.scss';
import message from './img/message@2x.png';
import calendar from './img/calendar-check-59@2x.png';
import phone from './img/phone-call@2x.png';

const Methods = ({showForm}) => (
  <ul className={classNames(styles.Methods, 'has-background-white')}>
    <li className={styles.Methods__method}>
      <a
        href="https://app.teamgantt.com/book-a-demo?ref=helpdocs"
        target="_blank"
      >
        <div className={styles.Methods__icon}>
          <img alt="schedule a call" src={calendar} />
        </div>
        <div className={styles.Methods__text}>
          <h4 className="is-size-5 has-text-weight-bold">Schedule live help</h4>
          <p>Book a call with one of our friendly experts.</p>
        </div>
      </a>
    </li>
    <li className={styles.Methods__method}>
      <a href="tel:+18884179380">
        <div className={styles.Methods__icon}>
          <img alt="give us a call" src={phone} />
        </div>
        <div className={styles.Methods__text}>
          <h4 className="is-size-5 has-text-weight-bold">Give us a call</h4>
          <p>
            <span className="has-text-black is-size-6">+1 (888) 417-9380</span>
            <br />
            <span className="has-text-grey is-size-7">
              Mon - Fri 9 am - 5 pm EST
            </span>
          </p>
        </div>
      </a>
    </li>
    <li className={styles.Methods__method}>
      <a href="#" onClick={showForm}>
        <div className={styles.Methods__icon}>
          <img alt="send us a message" src={message} />
        </div>
        <div className={styles.Methods__text}>
          <h4 className="is-size-5 has-text-weight-bold">Send us a message</h4>
          <p>We love your feedback and hearing what you have to say!</p>
        </div>
      </a>
    </li>
  </ul>
);

Methods.propTypes = {
  showForm: PropTypes.func.isRequired,
};

export default Methods;



// WEBPACK FOOTER //
// ./src/components/contact/Methods.js